import React from 'react';
import '../Styles/SignIn.css'

const SignIn = () => {
	return (
		<div id="SignIn" className="centered">
			<div className="gutter">
				<h1 className>
				
					Coming Soon
				</h1>
			</div>
		</div>	
	)
}

export default SignIn;